import { Fragment, type ReactNode } from 'react';
import { isOrgsEnabled } from '../flag';
import { useWorkspaceStore } from '../workspaceStore';

/**
 * Remounts everything below it when the workspace changes, so chat pages, lists and
 * hooks start fresh with the new workspace (and their query keys) instead of keeping
 * state from the other one. With the feature off the key is constant: no remount, no
 * change.
 */
export function WorkspaceScope({ children }: { children: ReactNode }) {
  const activeOrgId = useWorkspaceStore((s) => s.activeOrgId);
  const serverDisabled = useWorkspaceStore((s) => s.serverDisabled);
  const scope = isOrgsEnabled() && !serverDisabled && activeOrgId ? activeOrgId : 'personal';
  return <Fragment key={scope}>{children}</Fragment>;
}
